import React from 'react';
import PropTypes from 'prop-types';

import ContainedGrid, { Row, Column } from '@xingternal/xing-grid';

import styles from './ViewWrapper.css';

const ViewWrapperDefaultGrid = ({ children }) => (
  <ContainedGrid className={styles.container} type="wide">
    <Row>
      <Column
        size={12}
        offset={0}
        offsetDesktop={2}
        sizeDesktop={8}
        offsetTablet={1}
        sizeTablet={10}
      >
        {children}
      </Column>
    </Row>
  </ContainedGrid>
);

ViewWrapperDefaultGrid.propTypes = {
  children: PropTypes.node,
};

export { ViewWrapperDefaultGrid };
